module.exports = __webpack_public_path__ + "img/selected1-min.79e4c3b3.png";